import { combineReducers } from "redux";
import response from "./response.reducer";

const organizationReducer = combineReducers({
  response,
});

export default organizationReducer;
